import { render, staticRenderFns } from "./DebitForm.vue?vue&type=template&id=f3208860&"
import script from "./DebitForm.vue?vue&type=script&lang=js&"
export * from "./DebitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports